import { Folder, FolderOpen, Share2 } from "lucide-react";
import type { JSX } from "react";

import { SidebarItem, SidebarSection } from "../../../common/components/SidebarNav.js";
import { useFilesLocation } from "../filesLocation.js";
import { useFolder } from "../query/fileQueries.js";

/** Sidebar der Dateien-App: Bereiche und der Weg in den aktuellen Ordner. */
export function FilesSidebar(): JSX.Element {
  const location = useFilesLocation();
  const folder = useFolder(location.tab === "mine" ? location.folderId : null);

  const trail = folder.data ? [...folder.data.path, folder.data.folder] : [];

  return (
    <div>
      <SidebarSection title="Dateien">
        <SidebarItem
          label="Meine Dateien"
          icon={<Folder className="h-4 w-4" />}
          active={location.tab === "mine"}
          onClick={() => location.openTab("mine")}
        />
        <SidebarItem
          label="Für mich freigegeben"
          icon={<Share2 className="h-4 w-4" />}
          active={location.tab === "shared"}
          onClick={() => location.openTab("shared")}
        />
      </SidebarSection>

      {location.tab === "mine" && trail.length > 1 ? (
        <SidebarSection title="Pfad">
          {trail.map((entry, index) => (
            <div key={entry.id} style={{ paddingLeft: `${index * 0.75}rem` }}>
              <SidebarItem
                label={index === 0 ? "Meine Dateien" : entry.name}
                icon={<FolderOpen className="h-4 w-4" />}
                active={index === trail.length - 1}
                onClick={() => location.openFolder(index === 0 ? null : entry.id)}
              />
            </div>
          ))}
        </SidebarSection>
      ) : null}
    </div>
  );
}
